import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from 'components/ResponsiveImage';
import './MoreFeatureArticles.scss';
import cn from 'classnames';
import { breakpoints } from 'js/breakpoints';
import fallbackImageSrc from '../../assets/image-placeholder-light.svg';

const MoreFeatureArticlesItem = ({ text, image, url }) => {
  const fallbackImage = {
    src: fallbackImageSrc,
  };

  return (
    <a href={url} className="more-feature-articles__item">
      <div
        className={cn('more-feature-articles__item-image-container', {
          'more-feature-articles__item-image-container_no-image':
            !image || !image.src,
        })}
      >
        <ResponsiveImage
          {...(image ?? fallbackImage)}
          loading="lazy"
          className="more-feature-articles__item-image responsive-image_size_more-feature-articles"
          sources={[
            {
              width: 390,
              height: 220,
              media: breakpoints.xs,
            },
            {
              width: 727,
              height: 410,
              media: breakpoints.s,
            },
            {
              width: 380,
              height: 214,
              media: breakpoints.l,
            },
          ]}
        />
      </div>

      {text && <div className="more-feature-articles__item-text">{text}</div>}
    </a>
  );
};

MoreFeatureArticlesItem.propTypes = {
  image: PropTypes.exact(ResponsiveImage.propTypes),
  text: PropTypes.string,
  url: PropTypes.string,
};

export default MoreFeatureArticlesItem;
